import { UserOutlined } from '@ant-design/icons';
import { Avatar, type AvatarProps } from 'antd';

type Props = Omit<AvatarProps, 'src' | 'icon'> & {
  avatarUrl: string | null | undefined;
};

/**
 * Avatar with the standard fallback: shows the user's image when present, otherwise a generic
 * user icon. All other Avatar props (size, style, etc.) pass straight through.
 */
export const UserAvatar = ({ avatarUrl, ...rest }: Props) => (
  <Avatar src={avatarUrl ?? undefined} icon={avatarUrl ? undefined : <UserOutlined />} {...rest} />
);
